export interface EventStructuredData {
  "@context": "https://schema.org";
  "@type": "Event";
  name: string;
  description: string;
  startDate: string;
  endDate?: string;
  location: {
    "@type": "Place";
    name: string;
    address?: string;
  };
  organizer: {
    "@type": "Organization";
    name: string;
    url?: string;
  };
  image?: string;
  url?: string;
  price?: {
    "@type": "PriceSpecification";
    price: number;
    priceCurrency: string;
  };
  offers?: {
    "@type": "Offer";
    price: number;
    priceCurrency: string;
    availability: string;
    url?: string;
  };
}

export interface OrganizationStructuredData {
  "@context": "https://schema.org";
  "@type": "Organization";
  name: string;
  description: string;
  url?: string;
  logo?: string;
  image?: string;
  address?: {
    "@type": "PostalAddress";
    streetAddress?: string;
    addressLocality?: string;
    addressRegion?: string;
    postalCode?: string;
    addressCountry?: string;
  };
  contactPoint?: {
    "@type": "ContactPoint";
    telephone?: string;
    contactType?: string;
    email?: string;
  };
  sameAs?: string[];
}

export interface WebsiteStructuredData {
  "@context": "https://schema.org";
  "@type": "WebSite";
  name: string;
  description: string;
  url: string;
  potentialAction: {
    "@type": "SearchAction";
    target: string;
    "query-input": string;
  };
}

export function createEventStructuredData(event: {
  name: string;
  description: string;
  startDate: string;
  endDate?: string;
  location: string;
  organizer: string;
  image?: string;
  url?: string;
  price?: number;
}): EventStructuredData {
  return {
    "@context": "https://schema.org",
    "@type": "Event",
    name: event.name,
    description: event.description,
    startDate: event.startDate,
    endDate: event.endDate,
    location: {
      "@type": "Place",
      name: event.location
    },
    organizer: {
      "@type": "Organization",
      name: event.organizer
    },
    image: event.image,
    url: event.url,
    offers: event.price
      ? {
          "@type": "Offer",
          price: event.price,
          priceCurrency: "VND",
          availability: "https://schema.org/InStock",
          url: event.url
        }
      : undefined
  };
}

export function createOrganizationStructuredData(org: {
  name: string;
  description: string;
  url?: string;
  logo?: string;
  image?: string;
}): OrganizationStructuredData {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: org.name,
    description: org.description,
    url: org.url,
    logo: org.logo,
    image: org.image
  };
}

export function createWebsiteStructuredData(): WebsiteStructuredData {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Garther",
    description: "Nơi những cuộc gặp gỡ trở nên ý nghĩa",
    url: "https://garther.app",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://garther.app/event?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };
}
